
import React from "react";
import Btn from "../common/Btn";
import { i18nManager } from "../../i18n";
import { pagePath } from "../../helpers";
import styles from "../../assets/style.module.css";
import { ITeamMember, ITeamWebsite } from "../../../../../services";

export interface SquadGridProps {
    basePath: string;
    website: ITeamWebsite;
    members: ITeamMember[];
    onSelect: (m: ITeamMember) => void;
}

function SquadGrid({ website, basePath, members, onSelect }: SquadGridProps) {

    const labels = i18nManager.Labels.home;

    return (<section className={styles["section"]}>
        <div className={styles["container"]}>
            <div className={styles["split-head"]}>
                <h2 className={styles["d2"]}>{labels.squad_title}</h2>
                <div>
                    <p className={styles["lead"]}>{website.team.description || labels.squad_desc.replace(":name", website.team.name).replace(":count", `${members.length}`)}</p>
                    <Btn variant="text" to={pagePath(basePath, "MEMBERS")}>{labels.all_members}</Btn>
                </div>
            </div>
            <div className={styles["squad-grid"]}>
                {members.map((m) => (<button key={m.external_id} className={styles["squad-tile"]} onClick={() => onSelect(m)}>
                    <span className={styles["squad-tile-default"]}>
                        <img src={m.passport_picture_url} alt="" loading="lazy" />
                    </span>
                    <span className={styles["squad-tile-hover"]}>
                        <img src={m.half_body_picture_url || m.passport_picture_url} alt="" loading="lazy" />
                        <span className={styles["squad-tile-name"]}>{m.display_name}</span>
                    </span>
                </button>))}
            </div>
        </div>
    </section>);
}

export default SquadGrid;
